import { ProfessionalService } from 'data/services';
import { ProfessionalServiceInterface } from 'domain/services';
import { makeRemoteCreateProfessionalManagement } from 'main/factories/usecases/professionals/profissional-management/remote-create-professional-management-factory';
import { makeRemoteGetByIdProfessionalManagement } from 'main/factories/usecases/professionals/profissional-management/remote-get-by-id-professional-management-factory';
import { makeRemoteUpdateProfessionalManagement } from 'main/factories/usecases/professionals/profissional-management/remote-update-professional-management-factory';
import { makeRemoteGetAllProfessionals } from 'main/factories/usecases/professionals/remote-get-all-professionals-factory';
import { makeRemoteGetAllProfessionalsNotPaginated } from 'main/factories/usecases/professionals/remote-get-all-professionals-not-paginated-factory';
import { makeGetAllProfessionalsSelectOptions } from 'main/factories/usecases/professionals/remote-get-all-professionals-select-options-factory';
import { makeGetCheckProfessionalExists } from 'main/factories/usecases/professionals/remote-get-check-professional-exists-factory';
import { makeRemoteGetProfessionalOverview } from 'main/factories/usecases/professionals/remote-get-professional-overview-factory';
import { makeRemoteUnlinkProfessional } from 'main/factories/usecases/professionals/remote-unlink-professional-factory';

export const makeProfessionalService = (): ProfessionalServiceInterface => {
  return new ProfessionalService(
    makeRemoteGetAllProfessionals(),
    makeGetAllProfessionalsSelectOptions(),
    makeRemoteUnlinkProfessional(),
    makeGetCheckProfessionalExists(),
    makeRemoteCreateProfessionalManagement(),
    makeRemoteGetByIdProfessionalManagement(),
    makeRemoteUpdateProfessionalManagement(),
    makeRemoteGetAllProfessionalsNotPaginated(),
    makeRemoteGetProfessionalOverview(),
  );
};
